<template>
  <!-- Contenedor fijo full-width al fondo. El degradé tapa el contenido que
       scrollea detrás de la barra; la barra flotante va encima. -->
  <div class="lg:hidden fixed inset-x-0 bottom-0 z-30 pointer-events-none">
    <!-- Degradé hacia el color del fondo de la página, para que el contenido
         se desvanezca detrás de la barra y no asome al scrollear. -->
    <div class="nav-fade"></div>

    <!-- Barra flotante (opaca, no deja ver el contenido detrás) -->
    <nav
      class="nav-floating pointer-events-auto absolute left-3 right-3 h-14 flex items-center px-2 rounded-[20px] bg-white shadow-[0_6px_20px_rgba(0,0,0,0.14)]"
    >
      <!-- Indicador deslizante: pill amarillo translúcido detrás del item activo -->
      <span
        class="absolute top-1.5 bottom-1.5 rounded-[14px] bg-base-yellow/15 transition-transform duration-300 ease-out pointer-events-none"
        :style="indicatorStyle"
      ></span>

      <router-link
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        class="relative z-10 flex flex-col items-center justify-center gap-0.5 flex-1 h-full outline-none focus:outline-none transition-colors duration-200"
        :class="$route.path === item.to ? 'text-base-yellow' : 'text-base-gray-darker'"
        :aria-label="item.label"
      >
        <base-icon
          :name="$route.path === item.to ? item.iconActive : item.icon"
          class="w-6 h-6"
        />
        <span class="text-[10px] font-semibold">{{ item.label }}</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'MobileBottomNav',
  components: { BaseIcon },
  computed: {
    items() {
      return [
        { to: '/catalogo', label: 'Catálogo', icon: 'catalog', iconActive: 'catalog-filled' },
        { to: '/pedidos', label: 'Pedidos', icon: 'orders', iconActive: 'orders-filled' },
        { to: '/reclamos', label: 'Reclamos', icon: 'claims', iconActive: 'claims-filled' },
        { to: '/perfil', label: 'Perfil', icon: 'user', iconActive: 'user-filled' }
      ]
    },
    activeIndex() {
      const idx = this.items.findIndex((it) => it.to === this.$route.path)
      // Si la ruta no matchea ningún ítem dejamos el indicador en el primero
      // pero oculto vía opacidad, así no aparece flotando en otra sección.
      return idx >= 0 ? idx : 0
    },
    isOnNavRoute() {
      return this.items.some((it) => it.to === this.$route.path)
    },
    indicatorStyle() {
      const totalItems = this.items.length
      // El padding del nav es px-2 (8px). El span se posiciona dentro del flex,
      // así que el ancho real lo calculamos en % del contenedor (con calc para
      // descontar el padding lateral del nav).
      return {
        width: `calc((100% - 16px) / ${totalItems})`,
        transform: `translateX(calc(${this.activeIndex} * 100%))`,
        left: '8px',
        opacity: this.isOnNavRoute ? 1 : 0
      }
    }
  }
}
</script>

<style scoped>
/* Degradé al color del fondo de la página (#EBECEF). El contenido se
   desvanece detrás de la barra en vez de asomar con un corte/sombra. */
.nav-fade {
  height: 112px;
  background: linear-gradient(
    to top,
    #ebecef 0%,
    #ebecef 60%,
    rgba(235, 236, 239, 0) 100%
  );
}

/* La barra se separa del borde inferior y respeta el safe-area de iOS
   (home indicator), así queda siempre "abajo" sin pisar la barra del sistema. */
.nav-floating {
  bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
}
</style>
